import React from 'react';
import {
  Container,
  Header,
  SpaceBetween,
  FormField,
} from '@cloudscape-design/components';
import { Control, FieldErrors, UseFormResetField } from 'react-hook-form';
import { FormInput } from 'src/components/v2/FormInput';
import { FormTextEditor } from 'src/components/v2/FormTextEditor';
import { TranslationFormData } from 'src/validations/translationFormSchema';
import { QUESTION_FIELD_NAMES, QUESTION_FIELD_LABELS } from 'src/contstant/commonLabels';

interface TranslationTaskDetailsProps {
  control: Control<TranslationFormData>;
  errors: FieldErrors<TranslationFormData>;
  onTextEditorChange: (fieldName: string, value: string) => void;
  resetField: UseFormResetField<TranslationFormData>;
}

export const TranslationTaskDetails: React.FC<TranslationTaskDetailsProps> = ({
  control,
  errors,
  onTextEditorChange,
  resetField,
}) => {
  return (
    <Container header={<Header variant="h2">Task Details</Header>}>
      <SpaceBetween size="l">
        <FormField
          label={QUESTION_FIELD_LABELS[QUESTION_FIELD_NAMES.TASK_NAME]}
          stretch
          errorText={errors.taskName?.message}
        >
          <FormInput control={control} name={QUESTION_FIELD_NAMES.TASK_NAME} />
        </FormField>

        <FormTextEditor
          control={control}
          name={QUESTION_FIELD_NAMES.TASK_DESCRIPTION}
          label={QUESTION_FIELD_LABELS[QUESTION_FIELD_NAMES.TASK_DESCRIPTION]}
          showFileUpload={false}
          onChange={(value) =>
            onTextEditorChange(QUESTION_FIELD_NAMES.TASK_DESCRIPTION, value)
          }
          showRestoreButton={true}
          onRestore={() => resetField(QUESTION_FIELD_NAMES.TASK_DESCRIPTION)}
        />
      </SpaceBetween>
    </Container>
  );
};
